import { render } from "./BackToTop.vue?vue&type=template&id=d2dc404e&scoped=true&bindings={\"visible\":\"data\",\"onScroll\":\"options\",\"scrollTop\":\"options\"}"
import script from "./BackToTop.vue?vue&type=script&lang=js"
export * from "./BackToTop.vue?vue&type=script&lang=js"

import "./BackToTop.vue?vue&type=style&index=0&id=d2dc404e&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-d2dc404e"

export default script